export const DEFAULT_DATE_PATTERN = "yyyy-MM-dd HH:mm";
export const taskExecutorQueues = [
    {
        value: "DEFAULT",
        label: "Default"
    },
    {
        value: "FAST_COMPUTE",
        label: "Fast Compute"
    },
]

